'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CategoryService = function () {
  function CategoryService($http) {
    'ngInject';

    _classCallCheck(this, CategoryService);

    this.$http = $http;
  }

  _createClass(CategoryService, [{
    key: 'getDefaultQuery',
    value: function getDefaultQuery() {
      return _extends({}, (0, _query.getQuery)(), {
        orderBy: 'ProductCategoryName',
        direction: 'asc'
      });
    }
  }, {
    key: 'add',
    value: function add(category) {
      return this.$http.post('/api/product_category', category);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      return this.$http.delete('/api/product_category/' + id);
    }
  }, {
    key: 'update',
    value: function update(category) {
      return this.$http.put('/api/product_category/' + category.ProductCategoryId, category);
    }
  }, {
    key: 'search',
    value: function search(query) {
      return this.$http.get('/odata/ProductCategoryOData', {
        params: _extends({
          $select: 'ProductCategoryId, ProductCategoryName, ProductCount, ReportShortName'
        }, query.take && { $top: query.take }, query.page && { $skip: query.calculateSkip() }, {
          $orderby: query.orderBy + ' ' + query.direction
        }, query.filter && { $filter: query.filter.toString() }, {
          $count: true
        })
      });
    }
  }]);

  return CategoryService;
}();

exports.default = CategoryService;


// WEBPACK FOOTER //
// ./services/category.service.js